<template>
    <div>
        <nav class="navbar bg-white shadow-sm headerNav">
            <div class="bg-white nav-item headerNav-menu">

                <div class="bg-white headerNav-menu-sub d-none">
                    <div class="headerNav-menu-sub-item d-block"><i class="fas fa-bell nav-link p-0 navIcon navIconBell" data-toggle="tooltip" data-placement="bottom" title="Coming soon"></i></div>
                    <div class="d-none d-md-block headerNav-menu-sub-item verticalLine"></div>
                </div>

                <div class="dropdown-toggle headerNav-menu-toggler" role="button" id="navbarMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="fas fa-bars d-md-none headerNav-menu-toggler-bars"></span>
                    <div class="d-none d-md-block headerNav-menu-toggler-menu" v-if="user">
                        <div class="d-inline">{{name}}</div>
                        <div class="rounded-circle text-center d-none d-xl-block wbs-theme-bg text-white nameCircle">
                            {{tools.userInitials(user)}}
                        </div>
                    </div>
                </div>

                <div class="bg-white dropdown-menu headerNav-menu-toggler-dropdown" aria-labelledby="navbarMenu">
                    <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
                        <a class="dropdown-item text-center" target="_blank" v-bind:href="plexusFrontendDevConsoleUrl">Hardware Management
                        </a>
                        <div class="dropdown-divider"></div>
                    </RequiresGlobalPermissions>

                    <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
                        <router-link class="dropdown-item text-center" v-bind:to="{name:'site-management'}" v-on:click.native="resetSubUi('building-management')">Site Management
                        </router-link>
                        <div class="dropdown-divider"></div>
                    </RequiresGlobalPermissions>

                    <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
                        <router-link class="dropdown-item text-center" v-bind:to="{name:'warranty-management'}" v-on:click.native="resetSubUi('warranty-management')">Warranty Management
                        </router-link>
                        <div class="dropdown-divider"></div>
                    </RequiresGlobalPermissions>

                    <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
                        <router-link class="dropdown-item text-center" v-bind:to="{name:'email-management'}" v-on:click.native="resetSubUi('email-management')">Email Management
                        </router-link>
                        <div class="dropdown-divider"></div>
                    </RequiresGlobalPermissions>

                    <a class="dropdown-item text-center" title="User Profile" target="_blank" v-bind:href="accountSettingsUrl()">
                      Account <i style="margin-left: 4px;" class="fas fa-external-link-alt"></i>
                    </a>
                    <div class="dropdown-divider"></div>

                    <router-link class="dropdown-item text-center" v-bind:to="{name:'user-notification'}" title="Notification Management" v-on:click.native="resetSubUi('building-management')">Notifications
                    </router-link>
                    <div class="dropdown-divider"></div>

                    <a href="javascript:void(0)" class="dropdown-item text-center" v-on:click="logout">Logout</a>
                </div>
            </div>

            <div class="mx-auto logo">
                <div v-if="hasBuildingAccess">
                    <router-link v-bind:to="{name:'building-management'}" v-on:click.native="openSubUi('building-management')">
                        <img class="mx-auto inline-block" v-bind:src="getBrandingOptions().logoUrl" alt="Emiot">
                    </router-link>
                    <template slot="fallback">
                        <router-link v-bind:to="{name:'Home'}">
                            <img class="mx-auto inline-block" v-bind:src="getBrandingOptions().logoUrl"  alt="Emiot ">
                        </router-link>
                    </template>
                </div>
            </div>

        </nav>
        <div class="bg-white navSub">
            <ul class="nav justify-content-center text-center">
                <li class="nav-item" v-if="hasBuildingAccess">
                    <router-link class="nav-link" title="Dashboard" v-bind:to="{name:'dashboard'}" v-on:click.native="resetSubUi('building-management')"><i class="fas fa-tachometer-alt navIcon navIconQuestion"></i></router-link>
                </li>
                <li class="nav-item" v-if="hasBuildingAccess">
                    <router-link class="nav-link" title="Buildings" v-bind:to="{name:'building-management'}" v-on:click.native="openSubUi('building-management')"><i class="fas fa-building navIcon navIconQuestion"></i></router-link>
                </li>

                <li class="nav-item" v-if="hasBuildingAccess">
                    <router-link class="nav-link" title="Notification Management" v-bind:to="{name:'user-notification'}" v-on:click.native="resetSubUi('building-management')"><i class="fas fa-bell navIcon navIconQuestion"></i></router-link>
                </li>
                <li class="nav-item" v-if="hasBuildingAccess">
                    <router-link class="nav-link" title="Notification User" v-bind:to="{name:'building-user-management'}" v-on:click.native="resetSubUi('building-management')"><i class="fas fa-cog navIcon navIconQuestion"></i></router-link>
                </li>
            </ul>
        </div>
        <router-view class="container-fluid"></router-view>
    </div>
</template>

<script>
import RequiresGlobalPermissions from "@/components/RequiresGlobalPermissions";
import Tools from '@/app-model/tools.js';
import Building from '@/app-model/building.js';
import {getBrandingOptions} from '@/utils/getBrandingOptions.js'

export default {
    components: {
      RequiresGlobalPermissions
    },
    computed: {
      name: function() {
        const firebaseUser = this.$store.getters.firebaseUser;
        return firebaseUser?.displayName ? firebaseUser.displayName : 'Welcome';
      },
      buildingModel: function() {
        return new Building;
      },
      tools: function() {
        return new Tools;
      },
      /**
       * @return {boolean}
       */
      hasBuildingAccess () {
        return this.$store.getters.firebaseUser?.emailVerified;
      },
      user: function() {
        return this.$store.getters.firebaseUser;
      },
      plexusFrontendDevConsoleUrl: function() {
        return this.$store.getters.getSection('fixture').frontend_url.replace(/\/$/, '') +  '/dev';
      },
    },
    mounted () {
      this.load();
      jQuery('[data-toggle="tooltip"]').tooltip();
    },
    created () {
    },
    methods: {
      getBrandingOptions,
      accountSettingsUrl() {
        return `${getBrandingOptions().constructMonoAuthProfileUrl()}`;
      },
      async load () {
        if (!(await this.$store.dispatch('isLoggedIn'))) {
          await this.$store.dispatch('redirectTologin');
          return;
        }
        if (this.$route.path === '/') {
          if (this.hasBuildingAccess) {
            this.$store.state.router.push({name: 'dashboard'});
          } else {
            this.$store.state.router.push({name: 'user-notification'});
          }
        }
      },
      logout () {
        this.$store.dispatch('logout')
      },
      resetSubUi() {
        document.documentElement.classList.remove('building-management');
      },
      openSubUi() {
        this.resetSubUi();
        document.documentElement.classList.add('building-management');
      }
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_home.scss";
</style>